export enum formLayouts {
  VERTICAL = 'vertical',
}
